import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";
import { CONTACT, LOGO } from "../data/site";

export default function Footer() {
  return (
    <footer className="bg-navy text-cream relative overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="mb-5">
              <span className="inline-flex bg-white rounded-2xl p-4">
                <img src={LOGO.full} alt="The Thinkstitute" className="h-24 w-auto" />
              </span>
            </div>
            <p className="font-display text-3xl sm:text-4xl font-bold max-w-md leading-tight">
              Education <span className="text-marigold">Beyond</span> Textbooks.
            </p>
            <p className="mt-4 text-cream/70 max-w-sm">
              After-school coaching for Grades 7–12 in Vesu, Surat. Where curiosity
              meets rigour.
            </p>
          </div>

          <div>
            <h4 className="font-display font-bold text-lg mb-4 text-teal-brand">Explore</h4>
            <ul className="space-y-2 text-cream/80">
              <li><Link to="/" className="hover:text-marigold transition-colors">Home</Link></li>
              <li><Link to="/programs" className="hover:text-marigold transition-colors">Programs</Link></li>
              <li><Link to="/about" className="hover:text-marigold transition-colors">About</Link></li>
              <li><Link to="/gallery" className="hover:text-marigold transition-colors">Gallery</Link></li>
              <li><Link to="/admissions" className="hover:text-marigold transition-colors">Admissions</Link></li>
              <li><Link to="/admissions#faq" className="hover:text-marigold transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-lg mb-4 text-teal-brand">Reach Us</h4>
            <ul className="space-y-3 text-cream/80 text-sm">
              <li className="flex gap-3"><Phone size={18} className="text-marigold shrink-0" /><a href={`tel:${CONTACT.phone}`} className="hover:text-marigold">{CONTACT.phoneDisplay}</a></li>
              <li className="flex gap-3"><Mail size={18} className="text-marigold shrink-0" /><a href={`mailto:${CONTACT.email}`} className="hover:text-marigold break-all">{CONTACT.email}</a></li>
              <li className="flex gap-3"><Instagram size={18} className="text-marigold shrink-0" /><a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="hover:text-marigold">{CONTACT.instagramHandle}</a></li>
              <li className="flex gap-3"><MapPin size={18} className="text-marigold shrink-0" /><span>{CONTACT.address}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-cream/15 flex flex-col sm:flex-row justify-between gap-3 text-cream/50 text-sm">
          <p>© {new Date().getFullYear()} The Thinkstitute · thethinkstitute.in</p>
          <p>Made with curiosity in Surat.</p>
        </div>
      </div>
    </footer>
  );
}
